'use client'

import ShareBar from '@/components/story-detail/share-bar'
import { Button } from '@/components/ui/Button'
import { useState } from 'react'
import { RiCheckLine, RiFileCopyLine, RiShare2Line } from 'react-icons/ri'
import { BasicModal } from '../BasicModal'

export default function ShareModalTrigger({ url, quote }) {
  const [isModalOpen, setModalOpen] = useState(false)
  const [copied, setCopied] = useState(false)

  const handleClose = () => {
    setModalOpen(false)
    setCopied(false) // Reset copied state when closing modal
  }

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(url)
      setCopied(true)

      // Reset copied state after 2 seconds
      setTimeout(() => setCopied(false), 2000)
    } catch (err) {
      console.error('Failed to copy:', err)
    }
  }

  return (
    <>
      {/* Trigger Button */}
      <button
        className="inline-flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors group"
        onClick={() => setModalOpen(true)}
      >
        <RiShare2Line className="w-5 h-5" />
        <span className="byline">Share</span>
      </button>

      {/* Share Modal */}
      <BasicModal
        isOpen={isModalOpen}
        onClose={handleClose}
        className="max-w-md"
      >
        <div className="p-6 space-y-6">
          {/* Modal Heading */}
          <h2 className="font-serif text-2xl font-bold text-foreground pb-4 border-b-2 border-foreground">
            Share this story
          </h2>

          {/* Share Options */}
          <ShareBar url={url} quote={quote} />

          {/* Copy Link Button */}
          <Button variant="outline" onClick={handleCopyLink} className="w-full">
            {copied ? (
              <>
                <RiCheckLine className="w-4 h-4 mr-2 text-green-600" />
                Copied!
              </>
            ) : (
              <>
                <RiFileCopyLine className="w-4 h-4 mr-2" />
                Copy Link
              </>
            )}
          </Button>
        </div>
      </BasicModal>
    </>
  )
}
